import { Eye, EyeOff } from 'lucide-react'
import { ToolbarIconButton } from '@/components/ui/page-toolbar/ToolbarIconButton'

type Props = {
  valuesVisible: boolean
  onToggle: () => void
}

export function DashboardValuesToggle({ valuesVisible, onToggle }: Props) {
  return (
    <ToolbarIconButton
      active={valuesVisible}
      onClick={onToggle}
      title={valuesVisible ? 'Ocultar valores' : 'Mostrar valores'}
      aria-label={valuesVisible ? 'Ocultar valores' : 'Mostrar valores'}
    >
      {valuesVisible ? <Eye size={16} /> : <EyeOff size={16} />}
    </ToolbarIconButton>
  )
}
